import { configureStore, combineReducers } from "@reduxjs/toolkit";
import requestApprovalsReducer from "./Slice/requestApproval";
import complaintReducer from "./Slice/complaintSlice";
import orderReducer from "./Slice/OrderSlice";

const rootReducer = combineReducers({
  requestApprovals: requestApprovalsReducer,
  complaints: complaintReducer,
  order: orderReducer,
});
const store = configureStore({
  reducer: rootReducer,
});
export default store;
